/**
 *
 * @param {string} key The key to translate
 * @returns {string} The translated string
 */
export const translate = (key) => {
  const translations = window.__litium?.translation;
  if (translations)
    return window.__litium.translation[key] || `{{ ${key} }}`;
}

/**
 *
 * @param {string} string The string to parse
 * @param {{key: value}[]} values The values to replace
 * @returns {string} The string parsed with values
 */
export const replaceStringValues = (string, values) => {
  let result = string;
  for (const key in values) {
    const value = values[key];
    result = result.replace(`{{${key}}}`, value);
  }
  return result;
};
